import React from "react";
import {Button, Checkbox, Col, DatePicker, Form, Input, notification, Row, Select} from "antd";
import Divider from "antd/es/divider";
import BrdgxNationalitySelector from "./selector/BrdgxNationalitySelector";
import {
    createCorporateAccountUser, getCorporateAccountDetails,
    getCorporateAccountUserDetails,
    getCountryList, getIdType,
    getNationalityList
} from "../api/api";
import {displayError, displayGenericError} from "../common/notifications";
import BrdgxCountrySelector from "./selector/BrdgxCountrySelector";
import moment from "moment";
import OriginalIDTypeSelector from "./selector/OriginalIDTypeSelector";
import withUseIntl from "./withUseIntl";


export class CorporateAccountUserItem extends React.Component {
    state = {
        corporateAccountUsers: [{crpUserType: 'UBO', crpAccType: 'INDIVIDUAL', createWebUser:true}],
        nationalities: [],
        countries: [],
        idTypes:[]
    }

    componentWillReceiveProps(nextProps) {
        this.getCorporateAccountDetails();
    }

    getCorporateAccountDetails = () => {
        getCorporateAccountDetails()
            .then(corporateAccount => {
                if (corporateAccount.id) {
                    getCorporateAccountUserDetails(corporateAccount.id)
                        .then(corporateAccountUsers => {
                                if (corporateAccountUsers.length > 0) {


                                    corporateAccountUsers.map((user, idx) => {
                                        if (user.ubo) {
                                            user.crpUserType = 'UBO';
                                        } else if (user.shareholder) {
                                            user.crpUserType = 'Shareholder';
                                        } else if (user.director) {
                                            user.crpUserType = 'Director';
                                        } else if (user.authorizedPerson) {
                                            user.crpUserType = 'Authorized_User';
                                        }
                                    });

                                    this.setState({corporateAccountUsers})
                                }
                            }
                        )
                        .catch(displayGenericError);
                }
            });
    }

    componentDidMount() {
        this.getCorporateAccountDetails();
        getNationalityList()
            .then(response => {
                this.setState({
                    nationalities: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });
        getCountryList()
            .then(response => {
                this.setState({
                    countries: response
                });
            })
            .catch(error => {
                displayGenericError(error);
            });
        getIdType().then(response => {
            this.setState({
                idTypes: response
            });
        }).catch(error => {
            displayGenericError(error);
        });
    }

    onFieldChanged = (idx, field, val) => {
        let temp = this.state.corporateAccountUsers;
        let user = temp[idx];
        user[field] = val;

        this.setState({
            corporateAccountUsers: temp
        });
    }
    addNewCorporateAccountUser = () => {
        let temp = this.state.corporateAccountUsers;
        temp.push({crpUserType: 'UBO', crpAccType: 'INDIVIDUAL',  createWebUser:true});
        this.setState({
            corporateAccountUsers: temp
        })

    };
    isSubmitButtonDisabled = () => {
        return false;
    }
    handleSubmit = () => {
        if (!this.props.disabled) {
            let temp = this.state.corporateAccountUsers;
            const intl = this.props.useIntl;
            const EMAIL_REGEX = RegExp("[^@ ]+@[^@ ]+\\.[^@ ]+");
            let isValidEmail = [];
            temp.map((user, idx) => {
                if(user.email) {
                    if (!EMAIL_REGEX.test(user.email)) {
                        isValidEmail.push(false);
                    }
                }

                if (user.crpUserType === 'UBO') {
                    user.shareholder = false;
                    user.director = false;
                    user.authorizedPerson = false;
                    user.ubo = true;
                } else if (user.crpUserType === 'Shareholder') {
                    user.shareholder = true;

                    user.ubo = false;
                    user.director = false;
                    user.authorizedPerson = false;

                } else if (user.crpUserType === 'Director') {
                    user.director = true;

                    user.ubo = false;
                    user.shareholder = false;
                    user.authorizedPerson = false;

                } else if (user.crpUserType === 'Authorized_User') {
                    user.authorizedPerson = true;

                    user.ubo = false;
                    user.shareholder = false;
                    user.director = false;
                }
            });
            if(isValidEmail.length>0) {
                displayError(intl.formatMessage({id: "app.common.email.invalid"}))
                return;
            }

            this.setState({
                corporateAccountUsers: temp
            }, () => {
                createCorporateAccountUser(temp).then(rs => {
                    this.props.handleSubmit(false);
                }).catch(error => {
                    displayGenericError(error)
                })
            })
        } else {

        }

    }

    render() {
        return (
            <div className="general-info-tab">
                <div className="left-pane">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Button style={{float: 'right'}}
                                    type="primary"
                                    onClick={this.addNewCorporateAccountUser}>
                                Add Corporate Account User
                            </Button>
                        </Col>
                    </Row>
                    {this.state.corporateAccountUsers.map((user, idx) => {
                        return (
                            <div>

                                <Row gutter={16}>
                                    <Col className="gutter-row" span={12}>
                                        <Form.Item label="User Type" required="true">
                                            <Select style={{width: '100%'}}
                                                    name="crpUserType"
                                                    value={user.crpUserType ? user.crpUserType : "UBO"}
                                                    onChange={newValue => this.onFieldChanged(idx, "crpUserType", newValue)}
                                                    size={"large"}
                                                    disabled={this.props.disabled}>
                                                <Select.Option value="UBO">UBO</Select.Option>
                                                <Select.Option value="Shareholder">Shareholder</Select.Option>
                                                <Select.Option value="Director">Director</Select.Option>
                                                <Select.Option value="Authorized_User">Authorized User</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col className="gutter-row" span={12}>
                                        <Form.Item label="Account Type" required="true">
                                            <Select style={{width: '100%'}}
                                                    name="crpAccType"
                                                    value={user.crpAccType ? user.crpAccType : "INDIVIDUAL"}
                                                    onChange={newValue => this.onFieldChanged(idx, "crpAccType", newValue)}
                                                    size={"large"}
                                                    disabled={this.props.disabled}>
                                                <Select.Option value="INDIVIDUAL">INDIVIDUAL</Select.Option>
                                                <Select.Option value="CORPORATE">CORPORATE</Select.Option>
                                            </Select>

                                        </Form.Item>
                                    </Col>
                                </Row>
                                {user.crpAccType === "INDIVIDUAL" && (
                                    <div>
                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="First Name" required="true">
                                                    <Input
                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        value={user.firstName}
                                                        onChange={e => this.onFieldChanged(idx, "firstName", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Last Name" required="true">
                                                    <Input
                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        value={user.lastName}
                                                        onChange={e => this.onFieldChanged(idx, "lastName", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Nationality" required="true">
                                                    <BrdgxNationalitySelector
                                                        disabled={this.props.disabled}
                                                        placeholder="Nationality"
                                                        required="true"
                                                        size={"large"}
                                                        style={{width: '100%'}}
                                                        value={user.nationality ? user.nationality : ''}
                                                        nationalities={this.state.nationalities}
                                                        onChange={newValue =>
                                                            this.onFieldChanged(idx, "nationality", newValue)
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country of residency" required="true">
                                                    <BrdgxCountrySelector
                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        placeholder="Select Country"
                                                        required="true"
                                                        style={{width: '100%'}}
                                                        value={user.countryOfResidence}
                                                        countries={this.state.countries}
                                                        onChange={newValue =>
                                                            this.onFieldChanged(idx, "countryOfResidence", newValue)
                                                        }/>
                                                </Form.Item>
                                            </Col>
                                        </Row>



                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item
                                                    label="ID Type">
                                                    <OriginalIDTypeSelector
                                                        disabled={this.props.disabled}
                                                        placeholder='Id type'
                                                        value={user.idType}
                                                        idTypes={this.state.idTypes}
                                                        onChange={newValue =>
                                                            this.onFieldChanged(idx, "idType", newValue)
                                                        }/>
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item
                                                    label="ID Number"
                                                    required="true">
                                                    <Input name="idNumber"
                                                           disabled={this.props.disabled}
                                                           value={user.idNumber}
                                                           onChange={e =>
                                                               this.onFieldChanged(idx, "idNumber", e.target.value)}

                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Date Of Birth" required="true">

                                                    <DatePicker
                                                        size={"large"}
                                                        style={{width: '100%'}}
                                                        format={"DD/MM/YYYY"}
                                                        disabled={this.props.disabled}
                                                        value={user.dateOfBirth ? moment(user.dateOfBirth, "DD/MM/YYYY") : null}
                                                        onChange={(newValue, newValueStr) =>
                                                            this.onFieldChanged(idx, "dateOfBirth", newValueStr)
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country of birth" required="true">
                                                    <Input

                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        value={user.countryOfBirth}
                                                        onChange={e => this.onFieldChanged(idx, "countryOfBirth", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                            <Form.Item label="Email" required="true">
                                                <Input
                                                    size={"large"}
                                                    disabled={this.props.disabled}
                                                    value={user.email}
                                                    onChange={e => this.onFieldChanged(idx, "email", e.target.value)}
                                                />
                                            </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                )}

                                {user.crpAccType === "CORPORATE" && (
                                    <div>
                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Name of Business" required="true">
                                                    <Input
                                                        size={"large"}
                                                        value={user.corpName}
                                                        onChange={e => this.onFieldChanged(idx, "corpName", e.target.value)}
                                                        disabled={this.props.disabled}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Country" required="true">
                                                    <BrdgxCountrySelector
                                                        size={"large"}
                                                        style={{width: '100%'}}
                                                        disabled={this.props.disabled}
                                                        placeholder="Select Country"
                                                        required="true"
                                                        value={user.corpCountry}
                                                        countries={this.state.countries}
                                                        onChange={newValue =>
                                                            this.onFieldChanged(idx, "corpCountry", newValue)
                                                        }
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>


                                        <Row gutter={16}>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Business No.">
                                                    <Input
                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        value={user.idNumber}
                                                        onChange={e => this.onFieldChanged(idx, "idNumber", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col className="gutter-row" span={12}>
                                                <Form.Item label="Email" required="true">
                                                    <Input
                                                        size={"large"}
                                                        disabled={this.props.disabled}
                                                        value={user.email}
                                                        onChange={e => this.onFieldChanged(idx, "email", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    </div>

                                )}
                                {!user.id && (
                                <Checkbox checked={user.createWebUser}
                                          onChange={e => this.onFieldChanged(idx, 'createWebUser', e.target.checked)}>
                                    Create Web User
                                </Checkbox>)}
                                <Divider/>
                            </div>

                        )
                    })}
                    <Row gutter={24}>
                        <Col md={24}>
                            <div className="button-wrapper">
                                <Button className="bt-skip" onClick={this.props.prevTab}>
                                    Back
                                </Button>
                                <Button
                                    className="bt-next"
                                    type="primary"
                                    onClick={this.handleSubmit}
                                    disabled={this.isSubmitButtonDisabled()}>
                                    Submit
                                </Button>


                            </div>
                        </Col>
                    </Row>

                </div>
            </div>)
    }

}

export default withUseIntl(CorporateAccountUserItem)